(function () {

  // ─── Constants ───────────────────────────────────────────────────────────────

  var HAWKSEARCH_ADD_TO_CART_CURRENCY = "AUD";

  // Templates live in hawkSearchTemplates/*.js and are concatenated before this file.
  // JS strings keep Handlebars {{...}} out of initial page source
  // (crawlers were treating raw expressions in data/href attributes as URLs).
  var T = window.middysHawkSearchTemplates || {};

  // ─── Overlay / UI ────────────────────────────────────────────────────────────

  function setHawkSearchOverlay(visible) {
    var overlay = document.querySelector(".plp #middys-overlay");
    if (overlay) overlay.style.display = visible ? "block" : "none";
  }

  function getVersion() {
    var el = document.querySelector('hawksearch-search-results');
    return (el && el.getAttribute('data-version')) || '1';
  }

  // ─── Fetch Interceptor ───────────────────────────────────────────────────────

  function facetSelectionsFingerprint(facets) {
    if (!facets) return "{}";
    var keys = Object.keys(facets).sort();
    var normalized = {};
    keys.forEach(function (k) {
      var v = facets[k];
      normalized[k] = Array.isArray(v) ? v.slice().sort() : v;
    });
    return JSON.stringify(normalized);
  }

  function installHawkSearchFetchInterceptor() {
    var _fetch = window.fetch;
    var _lastFacetSelectionsJson = null;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : input instanceof Request ? input.url : "";
      var origin = window.location.origin;

      if (!url.startsWith("/api/hawksearch") && !url.startsWith(origin + "/api/hawksearch")) {
        return _fetch.call(this, input, init);
      }

      // Inject CSRF token into all HawkSearch API calls
      var tokenEl = document.querySelector("#hawksearchApi [name='__RequestVerificationToken']");
      var token = tokenEl ? tokenEl.value : "";
      var headers;
      if (init && init.headers instanceof Headers) {
        headers = new Headers(init.headers);
        headers.set("RequestVerificationToken", token);
      } else {
        headers = Object.assign({}, init && init.headers, { RequestVerificationToken: token });
      }
      init = Object.assign({}, init, { headers: headers });

      // Inject facet filters into search requests
      if (init.body && /\/search($|\/)/i.test(url)) {
        setHawkSearchOverlay(true);

        try {
          var body = JSON.parse(init.body);
          body.FacetSelections = body.FacetSelections || {};

          // HawkSearch derives initial FacetSelections from the page URL's query string.
          // Kentico appends ?administrationUrl=... when the page loads inside the CMS
          // Admin Portal preview iframe; that's not a real facet field and HawkSearch's
          // API rejects it with a 400, so strip it before the request is sent.
          delete body.FacetSelections["administrationUrl"];

          var searchEl = document.querySelector("hawksearch-search-results");

          // Enforce category hierarchy on landing pages
          if (searchEl && searchEl.getAttribute("data-is-category-landing-page") === "True") {
            if (!body.FacetSelections["category"]) body.FacetSelections["category"] = [];
            var hierarchyId1 = searchEl.getAttribute("data-hierarchy-id-1");
            var hierarchyId2 = searchEl.getAttribute("data-hierarchy-id-2");
            if (hierarchyId1 && body.FacetSelections["category"].indexOf(hierarchyId1) === -1) {
              body.FacetSelections["category"].push(hierarchyId1);
            }
            if (hierarchyId2 && body.FacetSelections["category"].indexOf(hierarchyId2) === -1) {
              body.FacetSelections["category"].push(hierarchyId2);
            }
          }

          // Enforce featured product group filter
          var featuredGroup = searchEl && searchEl.getAttribute("data-featured-product-group-name");
          if (featuredGroup) {
            body.FacetSelections["featured_product_group_id"] = [featuredGroup];
          }

          // Sync stock filter with ?stock URL param (default: all products)
          if (!body.FacetSelections["stock"]) {
            var stockParam = new URLSearchParams(window.location.search).get("stock");
            body.FacetSelections["stock"] = stockParam === "true" ? ["true"] : null;
          }

          // Facet refinements clear page in HawkSearch (page=undefined); force page 1 for the API.
          var facetFingerprint = facetSelectionsFingerprint(body.FacetSelections);
          if (_lastFacetSelectionsJson !== null && facetFingerprint !== _lastFacetSelectionsJson) {
            body.PageNo = 1;
          }
          _lastFacetSelectionsJson = facetFingerprint;

          applyHawkSearchRequestType(body);

          init = Object.assign({}, init, { body: JSON.stringify(body) });          
        } catch (e) {}
      }

      
      return _fetch.call(this, input, init);
    };
  }

  // ─── Hybrid Request Type ─────────────────────────────────────────────────────
  // Pronto/SKU identifiers and short keyword queries stay on DefaultSearch
  // (exact match + Did You Mean). Longer natural-language queries use UnifiedSearch.

  var PRODUCT_CODE_PATTERN = /^(?=.*\d)[a-z0-9._/-]{4,}$/i;
  var NON_OVERRIDABLE_REQUEST_TYPES = { ImageData: true };

  function chooseHawkSearchRequestType(keyword) {
    var query = (keyword || "").trim();
    var words = query.split(/\s+/).filter(Boolean);
    var looksLikeProductCode = PRODUCT_CODE_PATTERN.test(query);
    if (looksLikeProductCode || words.length <= 2) {
      return "DefaultSearch";
    }
    return "UnifiedSearch";
  }

  function getHawkSearchKeyword(request) {
    if (!request) return "";
    return request.Keyword || request.keyword || request.Query || request.query || "";
  }

  function applyHawkSearchRequestType(request) {
    if (!request || typeof request !== "object") return request;
    var current = request.RequestType || request.requestType;
    if (current && NON_OVERRIDABLE_REQUEST_TYPES[current]) return request;
    var next = chooseHawkSearchRequestType(getHawkSearchKeyword(request));
    request.RequestType = next;
    request.requestType = next;
    return request;
  }

  function installHybridSearchRequestType() {
    window.addEventListener("hawksearch:before-search-executed", function (event) {
      applyHawkSearchRequestType(event.detail);
    });
  }

  // ─── Initialization ───────────────────────────────────────────────────────────

  function initHawkSearch(clientId, endpointUrl, trackingEndpointUrl) {
    setHawkSearchOverlay(true);
    installHawkSearchFetchInterceptor();
    installHybridSearchRequestType();

    addEventListener("hawksearch:after-search-executed", function () {
      setHawkSearchOverlay(false);
    });

    addEventListener("hawksearch:search-failed", function () {
      setHawkSearchOverlay(false);
    });

    addEventListener("hawksearch:loaded", function () {
      var proxyBase = endpointUrl;

      // Rewrite /smartsearch URLs to the real landing page path so browser history stays correct
      (function patchHistoryForLandingPage() {
        var searchEl = document.querySelector("hawksearch-search-results");
        if (!searchEl) return;

        var landingPath = null;
        var featuredGroup = searchEl.getAttribute("data-featured-product-group-name");
        if (featuredGroup) {
          landingPath = "/featured-products/" + featuredGroup;
        } else if (searchEl.getAttribute("data-is-category-landing-page") === "True") {
          var category1 = searchEl.getAttribute("data-category-1");
          var category2 = searchEl.getAttribute("data-category-2");
          landingPath = "/c/" + category1;
          if (category2) landingPath += "/" + category2;
        }
        if (!landingPath && searchEl.getAttribute("data-is-search-request") === "False") {
          var currentPath = window.location.pathname.replace(/\/$/, "");
          landingPath = currentPath === "/c" ? "/c" : "/product-range";
        }
        if (!landingPath) return;

        function fixUrl(url) {
          if (!url) return url;
          try {
            var u = new URL(url, window.location.origin);
            if (u.pathname === "/smartsearch" || u.pathname === "/smartsearch/") {
              u.pathname = landingPath;
              return u.toString();
            }
          } catch (e) {}
          return url;
        }
        var _push = history.pushState.bind(history);
        var _replace = history.replaceState.bind(history);
        history.pushState = function (state, title, url) { return _push(state, title, fixUrl(url)); };
        history.replaceState = function (state, title, url) { return _replace(state, title, fixUrl(url)); };
      })();

      var initConfig = {
        clientId: clientId,
        strings: {
          placeholder: "Search products",
        },
        autocomplete: {
          endpointUrl: proxyBase,
          recommendationsEnabled: true,
          decodeQuery: true,
          minCharacterCount: 1,
        },
        components: {
          "search-field":         { template: T.searchField },
          "unifiedsearch-field":  { template: T.unifiedSearchField },
          autocomplete:           { template: T.autocomplete },
          "search-results-item":  { template: T.searchResultsItem },
          "search-results":       { template: T.searchResults },
          "search-results-list":  { template: T.searchResultsList },
          "facets-list":          { template: T.facetsList },
          "facet-wrapper":        { template: T.facetWrapper },
          "checkbox-list-facet":  { template: T.checkboxListFacet },
          sorting:                { template: T.sorting },
          "page-size":            { template: T.pageSize },
          pagination:             { template: T.pagination },
          "modified-query":       { template: T.modifiedQuery },
          "query-suggestions":    { template: T.querySuggestions },
        },
        search: {
          endpointUrl: proxyBase,
          url: "/smartsearch",
        },
        fieldMappings: {
          title: "product_name",
          imageUrl: "product_images",
          description: "product_description",
        },
      };

      if (trackingEndpointUrl && String(trackingEndpointUrl).trim() !== "") {
        initConfig.tracking = {
          endpointUrl: trackingEndpointUrl,
        };
      }

      HawkSearch.init(initConfig);
    });

    addEventListener("hawksearch:initialized", function () {
      // Fallback when API returns empty Url; build product page URL from id (prontocode)
      HawkSearch.handlebars.registerHelper("productUrl", function (productName, id) {
        var name = Array.isArray(productName) ? productName[0] : productName;
        var idVal = Array.isArray(id) ? id[0] : id;
        return "/p/" + getProductName(name) + "/" + (idVal ?? "");
      });
      HawkSearch.handlebars.registerHelper("productImageUrl", function (productImageUrl, width = 180, height = 180) {
        if (!productImageUrl) return "/images/product-default.png?f=png&w=" + width + "&h=" + height;
        if (productImageUrl.split(".").length > 1 && productImageUrl.split(".").length - 1 == "png") {
          return productImageUrl + "?f=png&w=" + width + "&h=" + height;
        } else {
          return productImageUrl + "?f=jpg&w=" + width + "&h=" + height;
        }
      });
      initSearchFieldHandlers();
    });
  }

  // ─── Search Field Handlers ────────────────────────────────────────────────────

  // Delegates all four handlers to the shadow root so they survive template re-renders.
  function attachSearchFieldHandlers(shadowRoot) {
    if (shadowRoot._middysHandlersAttached) return true;
    shadowRoot._middysHandlersAttached = true;

    // HawkSearch triggers search on keyup (checking event.code === 'Enter'),
    // not keydown. Dispatch keyup so HawkSearch picks it up.
    function dispatchSearchKeyup(input) {
      input.dispatchEvent(new KeyboardEvent("keyup", {
        key: "Enter", code: "Enter", keyCode: 13, which: 13, bubbles: true, cancelable: true
      }));
    }

    // Prevent native form navigation. Android keyboards sometimes fire submit directly
    // without a preceding keydown, so dispatch keyup here to trigger HawkSearch's search.
    shadowRoot.addEventListener("submit", function (e) {
      if (!e.target.classList.contains("search-field")) return;
      e.preventDefault();
      var input = e.target.querySelector("[hawksearch-input]");
      if (input) dispatchSearchKeyup(input);
    });

    // Prevent form submission on keyboard Enter. HawkSearch's own keydown listener
    // also fires and calls preventDefault when event.code is 'Enter'; this covers
    // Android keyboards that report key:'Enter' but code:'' (empty).
    shadowRoot.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && e.target.hasAttribute("hawksearch-input")) e.preventDefault();
    });

    // Android virtual keyboards fire keyup with key:'Enter' but code:'' (empty).
    // HawkSearch checks event.code so it silently ignores these. Re-dispatch with
    // code:'Enter' so HawkSearch's keyup listener triggers the search.
    var normalizingKeyup = false;
    shadowRoot.addEventListener("keyup", function (e) {
      if (!e.target.hasAttribute("hawksearch-input")) return;
      if (e.key !== "Enter") return;
      if (e.code === "Enter" || e.code === "NumpadEnter") return; // HawkSearch handles this itself
      if (normalizingKeyup) return;
      normalizingKeyup = true;
      dispatchSearchKeyup(e.target);
      normalizingKeyup = false;
    });

    shadowRoot.addEventListener("click", function (e) {
      var target = e.target;

      if (target.classList.contains("search-clear")) {
        var form = target.closest("form.search-field");
        var input = form && form.querySelector("[hawksearch-input]");
        if (input) {
          input.value = "";
          input.dispatchEvent(new Event("input", { bubbles: true }));
          input.focus();
          var ac = form.querySelector("hawksearch-autocomplete");
          if (ac) ac.style.display = "none";
        }
        return;
      }

      if (target.type === "submit" && target.closest("form.search-field")) {
        e.preventDefault();
        var form = target.closest("form.search-field");
        var input = form && form.querySelector("[hawksearch-input]");
        if (input) dispatchSearchKeyup(input);
      }
    });

    return true;
  }

  function initSearchFieldHandlers() {
    // Include unified field hosts — without these handlers the custom <form>
    // submits natively to /smartsearch?keyword=… (no requestType), racing the
    // UnifiedSearch SPA call and causing a second search without requestType.
    var hostSelector =
      "hawksearch-search-field, hawksearch-unifiedsearch-field, hawksearch-unified-search-field";
    var hosts = Array.from(document.querySelectorAll(hostSelector));

    // Also find any search fields nested inside hawksearch-search-results shadow DOM
    document.querySelectorAll("hawksearch-search-results").forEach(function (el) {
      if (el.shadowRoot) {
        el.shadowRoot.querySelectorAll(hostSelector).forEach(function (nested) {
          hosts.push(nested);
        });
      }
    });

    hosts.forEach(function (host) {
      function tryAttach(remaining) {
        var root = host.shadowRoot;
        if (root && root.querySelector("form.search-field")) {
          attachSearchFieldHandlers(root);
        } else if (remaining > 0) {
          setTimeout(function () { tryAttach(remaining - 1); }, 50);
        }
      }
      tryAttach(20);
    });
  }

  // ─── Product Name / URL Helpers ───────────────────────────────────────────────

  function getProductName(pname) {
    if (pname == null) return "";
    var name = Array.isArray(pname) ? (pname[0] ?? "") : pname;
    if (typeof name !== "string") return "";
    return name
      .replace(/[^\w\d]/ig, "-")
      .replace(/[ ]/g, "-")
      .replace(/-+/g, "-")
      .toLowerCase();
  }

  function getProductNameFromSlug(slug) {
    if (slug == null || typeof slug !== "string") return "";
    return slug
      .replace(/-+/g, " ")
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  // ─── Tracking Utilities ───────────────────────────────────────────────────────

  /** Returns true when HawkSearch tracking is loaded and exposes the given method. */
  function isHawkSearchTrackingReady(method) {
    return (
      typeof window.HawkSearch !== "undefined" &&
      HawkSearch.services &&
      HawkSearch.services.tracking &&
      typeof HawkSearch.services.tracking[method] === "function"
    );
  }

  /** Coerces val to a non-negative number, or NaN when invalid. */
  function toPositiveNumber(val) {
    if (val === undefined || val === null) return NaN;
    var n = Number(val);
    return isNaN(n) || n < 0 ? NaN : n;
  }

  /** Returns currency string, defaulting to "USD" when blank. */
  function normalizeCurrency(currency) {
    return currency != null && String(currency).trim() !== "" ? String(currency) : "USD";
  }

  /**
   * Wrapper for HawkSearch.services.tracking.trackPageLoad(pageType, uniqueProductId).
   * @param {string} uniqueProductId - Stable product identifier.
   */
  function trackHawkSearchPageLoad(uniqueProductId) {
    if (uniqueProductId === undefined || uniqueProductId === null || String(uniqueProductId).trim() === "") return;
    if (!isHawkSearchTrackingReady("trackPageLoad")) return;
    HawkSearch.services.tracking.trackPageLoad(1, String(uniqueProductId));
  }

  /**
   * Wrapper for HawkSearch.services.tracking.trackAddToCart(uniqueProductId, quantity, price, currency).
   * @param {string} uniqueProductId
   * @param {number} quantity
   * @param {number} price
   * @param {string} [currency] - Defaults to 'USD' when omitted or empty.
   */
  function trackHawkSearchAddToCart(uniqueProductId, quantity, price, currency) {
    if (uniqueProductId === undefined || uniqueProductId === null || String(uniqueProductId).trim() === "") return;
    if (!isHawkSearchTrackingReady("trackAddToCart")) return;
    var qty = toPositiveNumber(quantity);
    var pr = toPositiveNumber(price);
    if (isNaN(qty) || isNaN(pr)) return;
    HawkSearch.services.tracking.trackAddToCart(String(uniqueProductId), qty, pr, normalizeCurrency(currency));
  }

  /**
   * Wrapper for HawkSearch.services.tracking.trackAddToCartMultiple(items).
   * Each item: { productId, quantity, price, currencyIsoCode? } (currencyIsoCode defaults to 'USD').
   * @param {Array<{productId: string, quantity: number, price: number, currencyIsoCode?: string}>} items
   */
  function trackHawkSearchAddToCartMultiple(items) {
    if (!Array.isArray(items) || items.length === 0) return;
    if (!isHawkSearchTrackingReady("trackAddToCartMultiple")) return;
    var normalized = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || it.productId === undefined || it.productId === null || String(it.productId).trim() === "") continue;
      var qty = toPositiveNumber(it.quantity);
      var pr = toPositiveNumber(it.price);
      if (isNaN(qty) || isNaN(pr)) continue;
      normalized.push({
        productId: String(it.productId),
        quantity: qty,
        price: pr,
        currencyIsoCode: normalizeCurrency(it.currencyIsoCode),
      });
    }
    if (normalized.length === 0) return;
    HawkSearch.services.tracking.trackAddToCartMultiple(normalized);
  }

  /**
   * Wrapper for HawkSearch.services.tracking.trackOrder(orderId, items, subtotal, taxOrFees, orderTotal, currency).
   * @param {string} orderId
   * @param {Array<{ productId: string, quantity: number, price: number }>} items
   * @param {number} subtotal
   * @param {number} taxOrFees
   * @param {number} orderTotal
   * @param {string} [currency] - Defaults to 'USD' when omitted or empty.
   */
  function trackHawkSearchOrder(orderId, items, subtotal, taxOrFees, orderTotal, currency) {
    if (orderId === undefined || orderId === null || String(orderId).trim() === "") return;
    if (!Array.isArray(items) || items.length === 0) return;
    if (!isHawkSearchTrackingReady("trackOrder")) return;
    var normalized = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || it.productId === undefined || it.productId === null || String(it.productId).trim() === "") continue;
      var qty = toPositiveNumber(it.quantity);
      var pr = toPositiveNumber(it.price);
      if (isNaN(qty) || isNaN(pr)) continue;
      normalized.push({ productId: String(it.productId), quantity: qty, price: pr });
    }
    if (normalized.length === 0) return;
    var st = toPositiveNumber(subtotal);
    var fees = toPositiveNumber(taxOrFees);
    var tot = toPositiveNumber(orderTotal);
    if (isNaN(st) || isNaN(fees) || isNaN(tot)) return;
    HawkSearch.services.tracking.trackOrder(String(orderId), normalized, st, fees, tot, normalizeCurrency(currency));
  }

  /**
   * Map AddProductsToCart request body: {"CartProductIDs":[{ ProntoCode, Quantity, Price },...]} to HawkSearch tracking.
   * One line → trackHawkSearchAddToCart; multiple → trackHawkSearchAddToCartMultiple.
   * @param {string|{ CartProductIDs: Array<{ ProntoCode: string, Quantity: number, Price: number }> }} jsonOrObject
   */
  function trackHawkSearchAddToCartFromAddProductsToCartJson(jsonOrObject) {
    if (jsonOrObject == null) return;
    var p;
    try {
      p = typeof jsonOrObject === "string" ? JSON.parse(jsonOrObject) : jsonOrObject;
    } catch (e) {
      return;
    }
    var list = p && p.CartProductIDs;
    if (!list || !list.length) return;
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var row = list[i];
      if (!row || row.ProntoCode == null || String(row.ProntoCode).trim() === "") continue;
      var qty = toPositiveNumber(row.Quantity);
      var pr = toPositiveNumber(row.Price);
      if (isNaN(qty) || isNaN(pr)) continue;
      out.push({
        productId: String(row.ProntoCode),
        quantity: qty,
        price: pr,
        currencyIsoCode: HAWKSEARCH_ADD_TO_CART_CURRENCY,
      });
    }
    if (out.length === 0) return;
    if (out.length === 1) {
      trackHawkSearchAddToCart(out[0].productId, out[0].quantity, out[0].price, HAWKSEARCH_ADD_TO_CART_CURRENCY);
    } else {
      trackHawkSearchAddToCartMultiple(out);
    }
  }

  // ─── Search Field Toggle ─────────────────────────────────────────────────────

  var SEARCH_FIELD_PREF_KEY = "middys_search_field_pref";

  function applySearchFieldPref(unified, standard, btn, useUnified) {
    unified.style.display = useUnified ? "" : "none";
    standard.style.display = useUnified ? "none" : "";
    btn.querySelector(".search-field-toggle-label").textContent = useUnified ? "Default" : "Unified";
  }

  function initSearchFieldToggle() {
    var btn = document.querySelector(".search-field-toggle");
    if (!btn) return;

    var unified = document.querySelector(".search-field-unified");
    var standard = document.querySelector(".search-field-standard");
    if (!unified || !standard) return;

    var useUnified = localStorage.getItem(SEARCH_FIELD_PREF_KEY) === "unified";
    applySearchFieldPref(unified, standard, btn, useUnified);

    btn.addEventListener("click", function () {
      var nowUnified = unified.style.display === "none";
      localStorage.setItem(SEARCH_FIELD_PREF_KEY, nowUnified ? "unified" : "default");
      applySearchFieldPref(unified, standard, btn, nowUnified);
    });
  }

  document.addEventListener("DOMContentLoaded", initSearchFieldToggle);

  // ─── Public API ───────────────────────────────────────────────────────────────

  window.middysSmartSearch = {
    initHawkSearch: initHawkSearch,
    chooseHawkSearchRequestType: chooseHawkSearchRequestType,
    getVersion: getVersion,
    getProductNameFromSlug: getProductNameFromSlug,
    trackHawkSearchPageLoad: trackHawkSearchPageLoad,
    trackHawkSearchAddToCart: trackHawkSearchAddToCart,
    trackHawkSearchAddToCartMultiple: trackHawkSearchAddToCartMultiple,
    trackHawkSearchAddToCartFromAddProductsToCartJson: trackHawkSearchAddToCartFromAddProductsToCartJson,
    trackHawkSearchOrder: trackHawkSearchOrder,
  };
})();
